import React from "react";
import { Dropdown } from "../common/components/dropdown/Dropdown";
import useFormComponentState from "../common/forms/useFormComponentState";
import { winnersAndLosersYears } from "../search/searchOptions";

export function WinnersAndLosersTitle() {
	const { currentInput, onInputChangeAndSearch } = useFormComponentState(
		"year",
		"",
	);
	const dropdownToggle = currentInput.toString();

	return (
		<>
			Winners and Losers in
			<Dropdown
				dropdownToggle={dropdownToggle}
				dropdownItems={winnersAndLosersYears}
				onDropdownItemClick={(id, name) => onInputChangeAndSearch(name)}
				preselected={true}
				additionalClasses={{
					dropdown: "dropdown--search-title dropdown--right",
				}}
				dropdownKey="winners_and_losers_title"
			/>
		</>
	);
}
